import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const profileApi = {
  list: () => axios.get(`${API}/school-profiles`).then((r) => r.data),
  get: (id) => axios.get(`${API}/school-profiles/${id}`).then((r) => r.data),
  upsert: (profile, id) => axios.post(`${API}/school-profiles${id ? `?id=${id}` : ""}`, profile).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/school-profiles/${id}`).then((r) => r.data),
};

export const monthLockApi = {
  list: (schoolId) => axios.get(`${API}/month-locks`, { params: schoolId ? { schoolId } : {} }).then((r) => r.data),
  upsert: (payload) => axios.post(`${API}/month-locks`, payload).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/month-locks/${id}`).then((r) => r.data),
};
